module.exports = __webpack_public_path__ + "img/suzuki-ciaz.46735ea4.jpg";